/* eslint-disable import/no-extraneous-dependencies */
import { endOfMonth, format } from "date-fns";
/* eslint-enable import/no-extraneous-dependencies */
export const formatDateString = (year, month, day) => {
  const paddedDay = day ? String(day).padStart(2, "0") : "01";
  const paddedMonth = month ? String(month).padStart(2, "0") : "01";
  return `${year}-${paddedMonth}-${paddedDay}`;
};

export const formatDateForAPI = (date) => format(date, "yyyy-MM-dd");

export const getMonthOptions = () => [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const getMonthIndex = (monthName, monthOptions = getMonthOptions()) =>
  monthOptions.indexOf(monthName);

export const getLastDayOfMonth = (year, monthIndex) =>
  endOfMonth(new Date(year, monthIndex));

export const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 11 }, (_, i) => (currentYear - i).toString());
};

export const getDateRange = ({ year, month, fromDay, toDay }) => {
  if (!year) throw new Error("Year is required");

  const monthOptions = getMonthOptions();

  if (!month) {
    return {
      startDate: formatDateString(year, "01", "01"),
      endDate: formatDateString(year, "12", "31"),
    };
  }

  const monthIndex = getMonthIndex(month, monthOptions);
  if (monthIndex === -1) throw new Error("Invalid month");

  const monthNumber = String(monthIndex + 1).padStart(2, "0");

  if (!fromDay && !toDay) {
    const lastDay = getLastDayOfMonth(parseInt(year, 10), monthIndex);
    return {
      startDate: formatDateString(year, monthNumber, "01"),
      endDate: formatDateForAPI(lastDay),
    };
  }

  if (!fromDay) throw new Error("From day is required in day mode");

  const startDate = formatDateString(year, monthNumber, fromDay);
  let endDate;

  if (toDay) {
    const lastDay = getLastDayOfMonth(parseInt(year, 10), monthIndex);
    const maxDay = lastDay.getDate();
    const actualDay = Math.min(parseInt(toDay, 10), maxDay);
    endDate = formatDateString(year, monthNumber, actualDay);
  } else {
    endDate = formatDateForAPI(
      getLastDayOfMonth(parseInt(year, 10), monthIndex)
    );
  }

  return { startDate, endDate };
};
